export default {
    path: 'blog',
    component: () => import('../Blog.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Bài viết',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Bài viết',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Bài viết',
            component: () => import('../cu/CU.vue'),
        },
    ]
};